/**
 * make string insensitive
 */

const makeInsensitive = (string) => {
  return string.normalize('NFD').replace(/\p{Diacritic}/gu, '').toUpperCase()
}

export default makeInsensitive